import { Injectable } from '@angular/core';
import { WorkstateEnum } from '../enums/workstate-enum';
import { MachineService } from './machine.service';
import { subscribeOn } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { MachineV2Dto } from '../api/exa';

@Injectable({
  providedIn: 'root',
})
export class ColorService {
  static DEFAULT_COLOR = '#27a89a';

  colors: string[] = [];
  locationColorsTmp: string[] = [];

  constructor(
    private machineService: MachineService,
    private log: NGXLogger
  ) {
    /* exa */
    this.colors['exatrek'] = '#27a89a';
    this.colors['WAITING'] = '#ff7400';
    this.colors['IDLE'] = '#8b00ff';

    // workstates
    this.colors[WorkstateEnum.WORKING] = '#57b41a';
    this.colors[WorkstateEnum.TURNING] = '#006cff';
    this.colors[WorkstateEnum.ROAD] = '#ffff00';
    this.colors[WorkstateEnum.PREPARATION] = '#8b00ff';
    this.colors[WorkstateEnum.MISC_FIELD] = '#b41a1a';
    this.colors[WorkstateEnum.MISC_ROAD] = '#ff7400';
    this.colors[WorkstateEnum.TRANSPORT_LOADING] = '#006cff';
    this.colors[WorkstateEnum.TRANSPORT_UNLOADING] = '#4ebcff';
    this.colors[WorkstateEnum.TRANSPORT_UNLOADED] = '#95ff15';
    this.colors[WorkstateEnum.TRANSPORT_LOADED] = '#57b41a';
    this.colors[WorkstateEnum.DRIVING] = '#ffff00';
    this.colors[WorkstateEnum.DRIVING_MISC] = '#ff7400';
    this.colors[WorkstateEnum.MISC_FIELD_GRAINTANK_FULL] = '#ff000d';
    this.colors[WorkstateEnum.THRESHING] = '#57b41a';
    this.colors[WorkstateEnum.THRESHING_WITH_STRAWCHOPPER] = '#115900';
    this.colors[WorkstateEnum.THRESHING_UNLOADING] = '#95ff15';
    this.colors[WorkstateEnum.THRESHING_WITH_STRAWCHOPPER_UNLOADING] = '#298221';
    this.colors[WorkstateEnum.TRANSPORT_UNLOADING_DRIVING] = '#4ebcff';

    // processes codes
    this.colors['IMPLEMENT.PROCESS.0'] = '#42403A';
    this.colors['IMPLEMENT.PROCESS.1'] = '#B5DB00';
    this.colors['IMPLEMENT.PROCESS.2'] = '#E7C400';
    this.colors['IMPLEMENT.PROCESS.3'] = '#D70BD9';
    this.colors['IMPLEMENT.PROCESS.4'] = '#00CFB4';
    this.colors['IMPLEMENT.PROCESS.5'] = '#704800';
    this.colors['IMPLEMENT.PROCESS.6'] = '#664B31';
    this.colors['IMPLEMENT.PROCESS.7'] = '#AD6500';
    this.colors['IMPLEMENT.PROCESS.8'] = '#753A2B';
    this.colors['IMPLEMENT.PROCESS.9'] = '#B37200';
    this.colors['IMPLEMENT.PROCESS.10'] = '#5E4400';
    this.colors['IMPLEMENT.PROCESS.11'] = '#BD8A5B';
    this.colors['IMPLEMENT.PROCESS.12'] = '#B3B800';
    this.colors['IMPLEMENT.PROCESS.13'] = '#9C8D3D';
    this.colors['IMPLEMENT.PROCESS.14'] = '#0074C2';
    this.colors['IMPLEMENT.PROCESS.15'] = '#0A19CF';
    this.colors['IMPLEMENT.PROCESS.16'] = '#00D000';
    this.colors['IMPLEMENT.PROCESS.17'] = '#0C9400';
    this.colors['IMPLEMENT.PROCESS.18'] = '#fcf823';
    this.colors['IMPLEMENT.PROCESS.19'] = '#54635B';
    this.colors['IMPLEMENT.PROCESS.20'] = '#DCE6E1';
    this.colors['IMPLEMENT.PROCESS.21'] = '#AEB3B0';
    this.colors['IMPLEMENT.PROCESS.22'] = '#00D1E6';
    this.colors['IMPLEMENT.PROCESS.23'] = '#BDD9D2';
    this.colors['IMPLEMENT.PROCESS.24'] = '#C29B00';
    this.colors['IMPLEMENT.PROCESS.25'] = '#D99B0B';
    this.colors['IMPLEMENT.PROCESS.26'] = '#752500';
    this.colors['IMPLEMENT.PROCESS.27'] = '#CC6A3D';
    this.colors['IMPLEMENT.PROCESS.28'] = '#422314';
    this.colors['IMPLEMENT.PROCESS.29'] = '#FC5000';
    this.colors['IMPLEMENT.PROCESS.30'] = '#C23D00';
    this.colors['IMPLEMENT.PROCESS.31'] = '#4EF700';
    this.colors['IMPLEMENT.PROCESS.32'] = '#4E774B';
    this.colors['IMPLEMENT.PROCESS.33'] = '#4E774B';
    this.colors['IMPLEMENT.PROCESS.34'] = '#23BC33';
    this.colors['IMPLEMENT.PROCESS.35'] = '#54635B';
    this.colors['IMPLEMENT.PROCESS.36'] = '#C4CAC7';
    this.colors['IMPLEMENT.PROCESS.37'] = '#CF800A';
    this.colors['IMPLEMENT.PROCESS.38'] = '#C12300';
    this.colors['IMPLEMENT.PROCESS.39'] = '#1D7B8C';
    this.colors['IMPLEMENT.PROCESS.40'] = '#00695C';
    this.colors['IMPLEMENT.PROCESS.41'] = '#00A895';
    this.colors['IMPLEMENT.PROCESS.42'] = '#00F5D8';
    this.colors['IMPLEMENT.PROCESS.43'] = '#008F7E';
    this.colors['IMPLEMENT.PROCESS.44'] = '#F1EDF2';
    this.colors['IMPLEMENT.PROCESS.45'] = '#9F92A6';
    this.colors['IMPLEMENT.PROCESS.46'] = '#534659';
    this.colors['IMPLEMENT.PROCESS.47'] = '#FFAE55';
    this.colors['IMPLEMENT.PROCESS.48'] = '#FFAE55';
    this.colors['IMPLEMENT.PROCESS.49'] = '#A6AEC1';
    this.colors['IMPLEMENT.PROCESS.50'] = '#FFDC03';
    this.colors['IMPLEMENT.PROCESS.51'] = '#0C5100';
    this.colors['IMPLEMENT.PROCESS.52'] = '#176900';
    this.colors['IMPLEMENT.PROCESS.53'] = '#000000';
    this.colors['IMPLEMENT.PROCESS.54'] = '#000000';
    this.colors['IMPLEMENT.PROCESS.55'] = '#000000';
    this.colors['IMPLEMENT.PROCESS.56'] = '#000000';
    this.colors['IMPLEMENT.PROCESS.57'] = '#000000';
  }

  getColor(colorId: string): string {
    if (this.colors[colorId]) {
      return this.colors[colorId];
    }
    return '#000000';
  }

  getColorMachine(machine: MachineV2Dto): string {
    if (machine) {
      return '#' + machine.color;
    }
    return '#000000';
  }

  getColorMachineId(machineId: number): string {
    if (machineId) {
      const machine = this.machineService.getMachineById(machineId);
      if (machine) {
        return '#' + machine.color;
      }
    }
    return '#000000';
  }

  getColorLocationId(locationId: number): string {
    if (locationId) {
      if (this.locationColorsTmp[locationId]) {
        return this.locationColorsTmp[locationId];
      } else {
        // create new color ;)
        const color = this.getRandomColor();
        this.locationColorsTmp[locationId] = color;
        return color;
      }
    }
    return '#000000';
  }

  setColor(colorId: string, color: string) {
    this.colors[colorId] = color;
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
}
